<div
  *transloco="let t; read: 'metric-settings-modal'"
  class="xi-modal__container metric-settings-modal__container"
>
  <h2 class="xi-modal__title kxi-text-center">{{ t('title') }}</h2>

  <form [formGroup]="form" class="xi-modal__content metric-settings-modal__form">
    <app-metric-settings-form
      formControlName="main"
      [header]="t('main-metric')"
    ></app-metric-settings-form>

    <div class="metric-settings-modal__divider"></div>

    <app-metric-settings-form
      formControlName="driver"
      [header]="t('driver')"
    ></app-metric-settings-form>
  </form>

  <div class="xi-modal__actions metric-settings-modal__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button
      [text]="t('apply')"
      [disabled]="form.invalid"
      (onClick)="onApply()"
    ></xi-default-button>
  </div>
</div>
